import React from "react";
// NAVIGATION
import { useNavigate, useLocation } from "react-router-dom";
// ANT DESIGN COMPONENTS
import { Breadcrumb } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";

function LiftsBreadcrumb() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const [t] = useTranslation("global");
  const navigate = useNavigate();
  const location = useLocation();
  const idServer = new URLSearchParams(location.search).get("idServer");
  const idBank = new URLSearchParams(location.search).get("idBank");

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickServer = () => {
    navigate({
      pathname: "/edge-management/servers",
    });
  };

  const onClickBank = () => {
    let searchString = "";
    if (idServer && idServer !== "") {
      searchString = `?idServer=${idServer}`;
    }
    navigate({
      pathname: "/edge-management/banks",
      search: searchString,
    });
  };

  // ************************************************* */
  // USE EFFECT ************************************** */

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Breadcrumb className="">
      <Breadcrumb.Item>{t("header.edgeManagement")}</Breadcrumb.Item>
      {idServer && idServer !== "" && (
        <Breadcrumb.Item className="generalStyles__breadcrumbItemInactive" onClick={onClickServer}>
          {t("header.servers")}
        </Breadcrumb.Item>
      )}
      {idBank && idBank !== "" && (
        <Breadcrumb.Item className="generalStyles__breadcrumbItemInactive" onClick={onClickBank}>
          {t("header.banks")}
        </Breadcrumb.Item>
      )}
      <Breadcrumb.Item className="generalStyles__breadcrumbItem">
        {t("header.lifts")}
      </Breadcrumb.Item>
    </Breadcrumb>
  );
}

export default LiftsBreadcrumb;
